<template>
  <GlassCard class="mb-5 py-5 px-5">
    <div class="mt-5" v-if="this.method2FA">
      <p v-if="this.method2FA === 'EMAIL' || this.method2FA === 'Email'" class="email-text">
        {{ emailWasSendText }}
      </p>
      <p v-else-if="this.method2FA === 'EMAILGUARDIAN'" class="email-text">
        {{ emailWasSendTextGuardian }}
      </p>

      <div style="display: block">
        <input
          v-model="codeToSend"
          class="w-100 c-input"
          :placeholder="inputCodeText"
          @keyup.enter="validateCodeService"
          @paste="blockPaste"
        />

        <vs-alert v-if="validateErrMsg" class="mb-1 mt-2" color="#ffffff">
          <b :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #ff637e;'" style="font-size: 10px">
            <span :style="ownerId == 23 ? 'color: #fcff45;' : 'color: #ff637e;'">
              {{ validateErrMsg }}
            </span>
          </b>
        </vs-alert>

        <p
          class="mt-3 mr-4"
          style="font-size: 0.8rem; text-align: left"
          :style="template.secondaryTheme ? 'color: white;' : ''"
        >
          {{ mandatoryText }}
        </p>
      </div>

      <div>
        <button
          class="btn btn-block btn-black shadow-sm"
          type="submit"
          style="font-size: small; letter-spacing: 1px"
          :style="primaryBtnStyle"
          @click="validateCodeService"
        >
          {{ sendCodeBtnText }}
        </button>

        <button
          class="btn-block btn-dark btn shadow-sm"
          style="padding: 5px 0; font-size: small; letter-spacing: 1px"
          :style="secondaryBtnStyle"
          @click="goBack"
        >
          <i class="fa fa-caret-left"></i>
          {{ backToLoginText }}
        </button>

        <button
          type="submit"
          class="btn-block btn-dark btn shadow-sm"
          style="font-size: small; letter-spacing: 1px"
          :style="secondaryBtnStyle"
          :disabled="isResendDisabled"
          @click="resendOptionsArray.length > 1 ? openModal() : resendVerificationCodeService()"
        >
          {{ resendCodeBtnText }}

          <span v-if="isResendDisabled">({{ resendCodeTimer }})</span>
        </button>
      </div>
    </div>

    <!-- modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <button class="close-btn" @click="closeModal" title="Fechar modal">X</button>

        <span>
          Escolha a opção de <br />
          reenvio do código:
        </span>

        <div class="button-container">
          <button
            v-for="(option, index) in resendOptionsArray"
            :key="index"
            class="btn-option"
            :style="{ background: btnColor, color: btnTextColor }"
            @click="handleOptionClick(option)"
          >
            <i v-if="option == 'EMAIL'" class="mr-1">
              <svg width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"
                />
              </svg>
            </i>

            <i v-if="option == 'SMS'" class="mr-1">
              <svg width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                  d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L112 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8L352 304c-8.8 0-16-7.2-16-16s7.2-16 16-16l27.2 0c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240l0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"
                />
              </svg>
            </i>

            <i v-if="option == 'WHATSAPP'" class="mr-1">
              <svg width="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                />
              </svg>
            </i>

            {{ option }}
          </button>
        </div>
      </div>
    </div>
  </GlassCard>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

import store from '@/store/store.js'

import { loginFB } from '@/services/ServFB.js'

const lFB = new loginFB()

export default {
  name: 'TwoFactorsAuth',
  data: () => ({
    obj: {},
    codeToSend: '',
    method2FA: null,
    mandatoryText: '*Obrigatório',
    emailWasSendText:
      'Um código foi enviado para seu e-mail cadastrado. Por favor, nos informe o código recebido:',
    emailWasSendTextGuardian:
      'Um código foi enviado para o e-mail do responsável cadastrado. Por favor, nos informe o código recebido:',
    inputCodeText: 'Insira o código de confirmação',
    sendCodeBtnText: 'Validar',
    validateErrMsg: null,
    resendCodeBtnText: 'Reenviar código',
    resendCodeTimer: 60,
    isResendDisabled: true,
    backToLoginText: 'Voltar para login',
    showModal: false,
    resendOptionsArray: [],
    clientId: null,
  }),

  computed: {
    ...mapGetters(['primaryBtnStyle', 'secondaryBtnStyle']),
    ...mapState(['registrationObject', 'template', 'config']),
    primaryColor() {
      return store.state.template.primaryColor
    },
    btnColor() {
      return store.state.template.primaryBtn.bgColor
    },
    btnTextColor() {
      return store.state.template.primaryBtn.textColor
    },
  },

  mounted() {
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    this.method2FA = this.obj.method2FA
    this.startResendTimer()
    this.resendOptionsArray = this.$route.params.resendOptions
    this.clientId = this.$route.params.clientId
  },

  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),

    blockPaste() {
      return false
    },

    async getRedirectUrlService() {
      try {
        await lFB.GetRedirectUrl(this.obj.sessionToken)
      } catch (err) {
        this.$bvToast.toast(err, {
          title: `Erro!`,
          solid: true,
        })
      }
    },

    async validateCodeService() {
      this.validateErrMsg = false

      try {
        await lFB.validate2FACode(this.obj.sessionToken, this.codeToSend).then(
          data => {
            console.log('validate 2fa code: ', data)

            if (data.header.codigo === 1) {
              localStorage.setItem('session', this.obj.sessionToken)
              this.getRedirectUrlService()
            } else {
              console.log('setting validate error msg: ', data.header.msg)

              this.validateErrMsg = data.header.msg
            }
          },
          err => {
            console.log('validate 2fa error: ', err)

            this.$bvToast.toast(err, {
              title: 'Erro!',
              solid: true,
            })
          },
        )
      } catch (err) {
        console.log('validate 2fa fallback error: ', err)

        this.$bvToast.toast(err, {
          title: 'Error!',
          solid: true,
        })
      }
    },

    async resendVerificationCodeService(resendOption) {
      try {
        await lFB
          .resendVerificationCode(this.obj.sessionToken, this.clientId, resendOption)
          .then(data => {
            if (data.header.codigo === 1) {
              this.$bvToast.toast(data.data, {
                title: `Código de verificação enviado`,
                solid: true,
                autoHideDelay: 10000,
              })
            } else {
              this.$bvToast.toast(data.header.msg, {
                title: `Error!`,
                solid: true,
              })
            }
          })

        this.startResendTimer()
      } catch (err) {
        this.$bvToast.toast(err, {
          title: `Error!`,
          solid: true,
        })
      }
    },

    startResendTimer() {
      this.isResendDisabled = true
      this.resendCodeTimer = 60
      let timer = setInterval(() => {
        if (this.resendCodeTimer > 0) {
          this.resendCodeTimer--
        } else {
          this.isResendDisabled = false
          clearInterval(timer)
        }
      }, 1000)
    },

    openModal() {
      this.showModal = true
    },

    closeModal() {
      this.showModal = false
    },

    handleOptionClick(option) {
      this.resendVerificationCodeService(option.toLowerCase())
      this.closeModal()
    },

    goBack() {
      window.history.back()
    },
  },
}
</script>

<style scoped>
.email-text {
  color: white !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  color: #000;
  padding: 40px 20px 20px;
  border-radius: 8px;
  position: relative;
  text-align: center;
  width: 286px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: none;
  color: rgb(0, 0, 0);
  font-size: 20px;
  cursor: pointer;
}

.button-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}

.btn-option {
  width: 240px;
  margin: 5px;
  padding: 10px 15px;
  border: none;
  color: black;
  cursor: pointer;
  border-radius: 5px;
}
.btn-option:hover {
  background: #f4cd07;
}

@media screen and (min-width: 470px) {
  .modalContent {
    width: 435px;
  }
}

@media screen and (min-width: 767px) {
  .modalContent {
    width: 500px;
  }
}
</style>
